import React, { useRef } from "react";
import { uniqueId } from "lodash";

import { useDrag } from "react-dnd";
import { ROW } from "./DropConstants";
import DropZone from "./DropZone";
import Column from "./Column";

import DragIcon from '@mui/icons-material/DragIndicator';
import { withStyles } from '@mui/styles';
import UiPidsConstructorStyles from "../UiPidsConstructorStyles";
import CommonStyles from "../../../../common/CommonStyles";

const styles = {
  ...CommonStyles,
  ...UiPidsConstructorStyles,
};

const Row = ({ isForm, classes, data, ancestor, components, handleDrop,
  handleHtmlChange, handleRendererChange, path, setup_rbox_light }) => {
  const ref = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    type: data.type,//"sidebarItem",
    item: {
      type: ROW,
      id: data.id,
      children: data.children,
      path
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  const opacity = isDragging ? 0 : 1;
  drag(ref);

  const renderColumn = (column, currentPath) => {
    const temporaryId = uniqueId();
    return (
      <Column
        data={column}
        isForm={isForm}
        ancestor={ancestor}
        key={column.id || temporaryId}
        setup_rbox_light={setup_rbox_light}
        handleHtmlChange={handleHtmlChange}
        handleRendererChange={handleRendererChange}
        components={components}
        handleDrop={handleDrop}
        path={currentPath}
      />
    );
  };

  return (
    <div ref={preview} className={`${classes.style} ${classes.row} `} style={{ opacity }}>
      <div className={classes.columns}>
        <div ref={ref} className={classes.absolute} style={{ cursor: "move" }}>
          <DragIcon className={`drag-handle-icon ${classes.dragHandle}`} />
        </div>
        {data.children.map((column, index) => {
          const currentPath = `${path}-${index}`;
          const temporaryId = uniqueId();
          if (!column.id) column.id = temporaryId;

          return (
            <React.Fragment key={column.id}>
              <DropZone
                data={{
                  path: currentPath,
                  childrenCount: data.children.length,
                }}
                onDrop={handleDrop}
              />
              {renderColumn(column, currentPath)}
            </React.Fragment>
          );
        })}
        <DropZone
          data={{
            path: `${path}-${data.children.length}`,
            childrenCount: data.children.length
          }}
          onDrop={handleDrop}
          isLast
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(Row);
